'use client';
import { useRegisterPageViewParams } from '@nerdwallet/satellite';
import {
  useAnalytics,
  useAnalyticsPageView,
} from '@nerdwallet-cards/analytics';
import { type PropsWithChildren, type ReactNode } from 'react';

export const SatellitePageViewRegistration = ({
  children,
}: PropsWithChildren): ReactNode | undefined => {
  const { pageViewId, pageName, pageViewReady, contentId, contentSource } =
    useAnalyticsPageView();
  const { deployableName, deployableVersion } = useAnalytics();

  const params = pageViewReady
    ? {
        driverContentId: String(contentId) || '',
        driverContentSource: contentSource ?? 'wp',
        driverPageName: pageName,
        driverPageViewId: pageViewId,
        deployableName,
        deployableVersion,
      }
    : null;
  useRegisterPageViewParams(params);

  return children;
};
